import { Heading } from "../../components";
import UserProfile1 from "../../components/UserProfile1";
import React, { Suspense } from "react";

const expertProfilesList = [
  {
    userImage: "images/img_image_55.webp",
    userName: "Dr. Anil Sachdev",
    userLinkIcon: "images/img_link_blue_800.svg",
    userDescription:
      "Ex-Principal Technical Fellow General Motors R&D, Michigan, USA",
  },
  {
    userImage: "images/img_image_54.png",
    userName: "Dr. Vishal Agarwal",
    userLinkIcon: "images/img_link_blue_800.svg",
    userDescription:
      "Ex-GE, Siemens, Batelle; Business Development Director, Washington State University, USA",
  },
  {
    userImage: "images/img_image_56.png",
    userName: "Dr. Subir Bhowmick",
    userLinkIcon: "images/img_link.svg",
    userDescription: "Ex- Chief Scientist and Advisor, NAL, Bangalore, India",
  },
  {
    userImage: "images/img_image_57.png",
    userName: "Anand Rao",
    userLinkIcon: "images/img_link_blue_800_16x16.png",
    userDescription: "Managing Director, Icon Analytical",
  },
];

export default function AdvisorsSection() {
  return (
    <div className="flex flex-col items-center self-stretch pb-[60px]">
      <div className="container-xs flex flex-col gap-[54px] px-4 md:px-5 sm:gap-[27px]">
        {/* Heading */}
        <Heading
          size="heading16xl"
          as="h2"
          className="bg-gradient1 bg-clip-text text-[56.17px] font-bold text-transparent md:text-[48px] sm:text-[42px] text-center"
        >
          Our Advisors
        </Heading>

        {/* Advisors Profiles */}
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          <Suspense fallback={<div>Loading advisors...</div>}>
            {expertProfilesList.map((advisor, index) => (
              <UserProfile1 {...advisor} key={`advisorsList-${index}`} />
            ))}
          </Suspense>
        </div>
      </div>
    </div>
  );
}
